import { sizes } from "assets/constants";
import React, { PropsWithChildren } from "react";
import { SafeAreaView, StyleSheet, ViewProps, ViewStyle } from "react-native";

const SafeLayout: React.FC<PropsWithChildren<ViewProps>> = ({
  children,
  ...props
}) => {
  return (
    <SafeAreaView
      {...props}
      style={{ ...styles.container, ...(props.style as ViewStyle) }}
    >
      {children}
    </SafeAreaView>
  );
};

export default SafeLayout;

const styles = StyleSheet.create({
  container: { flex: 1, paddingHorizontal: sizes.space },
});
